import state from "./moduleCommonsState.js";
import mutations from "./moduleCommonsMutations.js";
import actions from "./moduleCommonsActions";
import getters from "./moduleCommonsGetters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
